import i1 from '../assets/issues/i1.png';
import i2 from '../assets/issues/i2.png';
import i3 from '../assets/issues/i3.png';
import i4 from '../assets/issues/i4.png';
import i5 from '../assets/issues/i5.png';
import i6 from '../assets/issues/i6.png';
import i7 from '../assets/issues/i7.png';
import i8 from '../assets/issues/i8.png';
import i9 from '../assets/issues/i9.png';
import i10 from '../assets/issues/i10.png';
import i11 from '../assets/issues/i11.png';
import i12 from '../assets/issues/i12.png';
import i13 from '../assets/issues/i13.png';
import i14 from '../assets/issues/i14.png';
import i15 from '../assets/issues/i15.png';
import i16 from '../assets/issues/i16.png';
import i17 from '../assets/issues/i17.png';
import i18 from '../assets/issues/i18.png';
import i19 from '../assets/issues/i19.png';
import i20 from '../assets/issues/i20.png';
import i21 from '../assets/issues/i21.png';

export const allIssues = [
  {
    id: 1,
    theme: '풋', //
    thumbnail: i1, // 위에서 import한 변수명
  },
  {
    id: 2,
    theme: '꽃다발', //
    thumbnail: i2,
  },
  {
    id: 3,
    theme: '거짓말',
    thumbnail: i3,
  },
  {
    id: 4,
    theme: '종합캔디',
    thumbnail: i4,
  },
  {
    id: 5,
    theme: '1/2',
    thumbnail: i5,
  },
  {
    id: 6,
    theme: '물품보관함',
    thumbnail: i6,
  },
  {
    id: 7,
    theme: '피서',
    thumbnail: i7,
  },
  {
    id: 8,
    theme: '습관',
    thumbnail: i8,
  },
  {
    id: 9,
    theme: '정체기',
    thumbnail: i9,
  },
  {
    id: 10,
    theme: '연착',
    thumbnail: i10,
  },
  {
    id: 11,
    theme: '성탄 나무 소설 걸렸네',
    thumbnail: i11,
  },
  {
    id: 12,
    theme: '늘어난 목티',
    thumbnail: i12,
  },
  {
    id: 13,
    theme: '약속',
    thumbnail: i13,
  },
  {
    id: 14,
    theme: '봄볕',
    thumbnail: i14,
  },
  {
    id: 15,
    theme: '이사',
    thumbnail: i15,
  },
  {
    id: 16,
    theme: '그럼에도',
    thumbnail: i16,
  },
  {
    id: 17,
    theme: '괴담',
    thumbnail: i17,
  },
  {
    id: 18,
    theme: '환승',
    thumbnail: i18,
  },
  {
    id: 19,
    theme: '참을 수 없는',
    thumbnail: i19,
  },
  {
    id: 20,
    theme: '일교차',
    thumbnail: i20,
  },
  {
    id: 21,
    theme: '별거 아닌',
    thumbnail: i21,
  },
];
